import apiClient from '@/api/apiClient.js';
import { getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    recordHCP: [],
    recordProfes: [],
    recordTransfers: [],
    codeTransfer: '',
    status: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    recordHCP(state) {
      return state.recordHCP;
    },
    recordProfes(state) {
      return state.recordProfes;
    },
    recordTransfers(state) {
      return state.recordTransfers;
    },
    codeTransfer(state) {
      return state.codeTransfer;
    },
    status(state) {
      return state.status;
    },
  },

  mutations: {
    insertSchema(state, schema) {
      state.schema = schema;
    },
    insertRecordHCP(state, recordHCP) {
      state.recordHCP = recordHCP;
    },
    insertRecordProfes(state, recordProfes) {
      state.recordProfes = recordProfes;
    },
    insertRecordTransfers(state, recordTransfers) {
      state.recordTransfers = recordTransfers;
    },
    insertCodeTransfer(state, codeTransfer) {
      state.codeTransfer = codeTransfer;
    },
    saveData(state) {
      state.status = 'success';
    },
    saveError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async loadSchema({ commit, rootState }) {
      try {
        const res = await apiClient.patRecordASchema();
        const schema = res.data;

        const isNew = rootState.authPat?.authData?.coNew === true;

        if (isNew) {
          delete schema.coBtnIcons[0].update;
          schema.coBtnIcons[0].btnResults = false;
        } else {
          delete schema.coBtnIcons[0].calification;
          schema.coBtnIcons[0].btnResults = true;
        }
        
        commit('insertSchema', schema);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async loadRecordHCP({ commit }) {
      try {
        const id = getPatPatientsId();
        let res = await apiClient.recordHCP(id);
        let recordHCP = res.data.data;

        commit('insertRecordHCP', recordHCP);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async loadRecordProfes({ commit }) {
      try {
        const id = getPatPatientsId();
        const res = await apiClient.recordProfes(id);
        const recordProfes = res.data.data;

        commit('insertRecordProfes', recordProfes);
      } catch (e) {
        console.error(e);
        commit('insertRecordProfes');
      }
    },

    async loadRecordTransfers({ commit }) {
      try {
        const id = getPatPatientsId();
        const res = await apiClient.recordTransfers(id);
        const recordTransfers = res.data.data;

        commit('insertRecordTransfers', recordTransfers);
      } catch (e) {
        console.error(e);
        commit('insertRecordTransfers');
      }
    },

    async saveTransfer({ commit }, model) {
      try {
        const res = await apiClient.saveRecordTransfers(model);
        const codeTransfer = res.data.data;
        
        commit('insertCodeTransfer', codeTransfer);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error guardando');
        commit('saveError');
        throw error;
      }
    },
  },
};
